import { render, staticRenderFns } from "./AllRelationsMap.vue?vue&type=template&id=1bcf3ff6&scoped=true"
import script from "./AllRelationsMap.vue?vue&type=script&lang=ts"
export * from "./AllRelationsMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf3ff6",
  null
  
)

export default component.exports